define('plugin/package/view/PackageInvoiceNotificationView',['require','lib/view/LayoutView'],function (require) {

    var Parent = require('lib/view/LayoutView');

    /**
     * Package invoice notification view
     *
     * @class PackageInvoiceNotificationView
     */
    return Parent.extend({

        template: '#package_invoice_notification_view',

        modelEvents: {
            'error:package': 'render'
        },

        serializeData: function () {
            return _.extend(Parent.prototype.serializeData.apply(this), {
                package_error: this.model.getPackageError()
            });
        }

    });

});
